export const jobTitles = [
  "Account Manager (AM)",
  "Administrative Assistant (AA)",
  "Artistic Director (DA)",
  "Assistant Executive (AE)",
  "Automation Engineer (AE)",
  "Backend Developer (BD)",
  "Business Analyst (BA)",
  "Business Developer (BD)",
  "Chief Administrative and Financial Officer (CAFO)",
  "Chief Administrative Officer (CAO)",
  "Chief Data Officer (CDO)",
  "Chief Digital Officer (CDO)",
  "Chief Executive Officer (CEO)",
  "Chief Financial Officer (CFO)",
  "Chief Human Resources Officer (CHRO)",
  "Chief Information Officer (CIO)",
  "Chief Marketing Officer (CMO)",
  "Chief Operating Officer (COO)",
  "Chief Product Officer (CPO)",
  "Chief Security Officer (CSO)",
  "Chief Technology Officer (CTO)",
  "Cloud Architect (CA)",
  "Cloud Engineer (CE)",
  "Commercial Director (CD)",
  "Commercial Engineer (CI)",
  "Communication Manager (ComM)",
  "Community Manager (CM)",
  "Compliance Officer (CO)",
  "Consultant (C)",
  "Controller (C)",
  "Copywriter (CW)",
  "CRM Manager (RCRM)",
  "Customer Success Manager (CSM)",
  "Cybersecurity Analyst (CA)",
  "Cybersecurity Specialist (CS)",
  "Data Analyst (DA)",
  "Data Engineer (DE)",
  "Data Scientist (DS)",
  "Database Administrator (DBA)",
  "Deputy General Manager (DGM)",
  "DevOps Engineer (DOE)",
  "Digital Director (DD)",
  "Director of Communications (DCom)",
  "Director of Creation (DC)",
  "Director of Innovation (DI)",
  "Director of Partnerships (DP)",
  "Director of Production (DP)",
  "Director of Projects (DP)",
  "Director of Purchasing (DP)",
  "Director of Research and Development (DRD)",
  "Director of Sales (DS)",
  "E-commerce Director (ECD)",
  "E-commerce Manager (ECM)",
  "Executive Assistant (EA)",
  "Financial Analyst (FA)",
  "Financial Controller (FC)",
  "Financial Manager (FM)",
  "Frontend Developer (FD)",
  "Full Stack Developer (FSD)",
  "Growth Hacker (GH)",
  "HR Business Partner (HRBP)",
  "Innovation Manager (IM)",
  "IT Director (ITD)",
  "IT Manager (ITM)",
  "IT Support Specialist (ITSS)",
  "Lead Developer (LD)",
  "Legal Director (LD)",
  "Logistics Coordinator (LC)",
  "Logistics Manager (LM)",
  "Marketing Manager (MM)",
  "Mechanical Engineer (ME)",
  "Mobile Developer (MD)",
  "Network Administrator (NA)",
  "Network Engineer (NE)",
  "Office Manager (OM)",
  "Operations Analyst (OA)",
  "Operations Director (OD)",
  "Product Development Manager (PDM)",
  "Product Manager (PM)",
  "Product Owner (PO)",
  "Production Director (PD)",
  "Project Manager (PM)",
  "Purchasing Manager (PM)",
  "Quality Director (QD)",
  "Quality Engineer (QE)",
  "Quality Manager (QM)",
  "R&D Manager (RDM)",
  "Research and Development Director (RDD)",
  "Research and Development Manager (RDM)",
  "Sales Director (SD)",
  "Sales Manager (SM)",
  "Scrum Master (SM)",
  "Security Engineer (SE)",
  "Security Manager (RM)",
  "Social Media Manager (SMM)",
  "Software Architect (SA)",
  "Software Engineer (SE)",
  "Solutions Architect (SA)",
  "Supply Chain Manager (SCM)",
  "Systems Administrator (SA)",
  "Technical Director (TD)",
  "Technician (TI)",
  "Technician Network (TN)",
  "UI/UX Designer (UI/UXD)",
  "Web Designer (WD)",
  "Web Developer (WD)",
  "Other"
];


export const employeeLevels = [
  "Apprentice",
  "Associate",
  "Chief Officer (C-suite)",
  "Consultant",
  "Department Head",
  "Director",
  "Entry-Level",
  "Executive Vice President",
  "Finance Director",
  "Founder",
  "General Manager",
  "Human Resources Director",
  "Intern",
  "Junior Associate",
  "Junior Consultant",
  "Manager",
  "Marketing Director",
  "Mentor",
  "Mid-Level",
  "Operations Director",
  "Owner",
  "Principal",
  "Project Director",
  "Project Manager",
  "Senior",
  "Senior Consultant",
  "Senior Vice President",
  "Team Leader",
  "Technical Director",
  "Vice President",
  "Other"
];


export const departments = [
  "Accounting",
  "Business Intelligence (BI)",
  "Communication",
  "Compliance and Regulatory",
  "Corporate Strategy",
  "Customer Service",
  "Data Analysis",
  "Engineering",
  "Finance",
  "Human Resources",
  "Information Technology (IT)",
  "Legal Department",
  "Logistics",
  "Market Research",
  "Marketing",
  "Product Development",
  "Production",
  "Project Management",
  "Public Relations",
  "Purchasing",
  "Quality Assurance",
  "Research and Development (R&D)",
  "Risk Management",
  "Sales",
  "Strategic Planning",
  "Supply Chain Management",
  "Sustainability",
  "Talent Management",
  "Technical Support",
  "Training and Development",
  "Other"
];


export const investmentTypes = [
  "Equity Investment",
  "Debt Investment",
  "Convertible Note",
  "SAFE (Simple Agreement for Future Equity)",
  "Revenue-Based Financing",
  "Venture Capital",
  "Angel Investment",
  "Crowdfunding",
  "Grants and Subsidies",
  "Corporate Investment",
  "Private Equity",
  "IPO (Initial Public Offering)",
  "Strategic Partnership",
  "Joint Venture",
  "Bridge Financing",
  "Royalty-Based Investment",
  "Impact Investment",
  "Microfinance Investment",
  "Family Office Investment",
  "Incubation and Acceleration Investment",
  "Friends and Family Round",
  "Convertible Debt",
  "Growth Equity",
  "Secondary Market Investment",
  "Acquisition Financing",
  "Leverage Buyout",
  "Token Sale (ICO/STO)",
  "Grants from Foundations",
  "Licensing Agreement",
  "Government Loan Programs",
  "Other"
];


export const reasonsForRejectionInvestment = [
  "Incomplete Profile",
  "Irrelevant Project",
  "Insufficient Information",
  "Criteria Not Met",
  "Misaligned Objectives",
  "Limited Experience",
  "Non-Priority Sector",
  "High Financial Risk",
  "Underqualified Team",
  "Documents Unavailable",
  "Unstable Business Model",
  "Uncertain Growth Strategy",
  "Low Market Traction",
  "Lack of Innovation",
  "Early-Stage Project",
  "Non-Compliance with Standards",
  "High Competition",
  "No Intellectual Property",
  "Missing Exit Strategy",
  "Unrealistic Profit Expectations",
  "Weak Financial History",
  "Limited Expansion Potential",
  "Excessive Capital Requirement",
  "Lack of Clear Vision",
  "Portfolio Exposure to Sector",
  "Leadership Instability",
  "Insufficient Communication",
  "Uncertain ROI",
  "Extended Timeline",
  "Misalignment with Values",
  "Other"
];


export const typesOfSponsoring = [
  "Financial Support",
  "In-Kind Contributions",
  "Product Provision",
  "Media Coverage",
  "Logistical Support",
  "Skills and Expertise",
  "Technology Partner",
  "Equipment Supply",
  "Catering Services",
  "Transportation Services",
  "Activity Sponsorship",
  "Award Sponsorship",
  "Communications Support",
  "Digital Partnership",
  "Social Media Collaboration",
  "Advertising Space",
  "Influencer Marketing",
  "Hospitality Services",
  "Ticketing Support",
  "Exclusive Rights",
  "Event Hosting",
  "Academic Partnership",
  "Sports Sponsorship",
  "Cultural Partnership",
  "Environmental Initiatives",
  "Social Responsibility",
  "Training and Workshops",
  "Humanitarian Support",
  "Innovation Partner",
  "Sustainability Initiatives",
  "Other"
];


export const reasonsForRejectionSponsoring = [
  "Budget Constraints",
  "Irrelevant Proposal",
  "Criteria Not Met",
  "Lack of Synergy",
  "Low Media Exposure",
  "Insufficient Contribution",
  "No Mutual Benefit",
  "Other Priorities",
  "Non-Targeted Sector",
  "Sponsor Conflict",
  "Resource Unavailability",
  "Environmental Misalignment",
  "Complex Implementation",
  "Low Visibility",
  "High Logistical Demand",
  "Exclusive Rights Issue",
  "Strategy Misalignment",
  "Policy Violation",
  "Long Timeline",
  "Inadequate Funding",
  "Brand Misalignment",
  "Team Unavailability",
  "No Long-Term Commitment",
  "High Risk",
  "Scope Exceeded",
  "Unrealistic Expectations",
  "Lack of Innovation",
  "Administrative Burden",
  "Negative Past Feedback",
  "Unclear Objectives",
  "Other"
];


export const InvestorCompanyTypes = [
  "Business Angels",
  "Venture Capital",
  "Private Equity",
  "Pension Funds",
  "Institutional Investors",
  "Strategic Investors",
  "Crowdfunding Investors",
  "Family Offices",
  "Cryptocurrency Investors",
  "Impact Investors",
  "Corporate Venture Capital",
  "Sovereign Wealth Funds",
  "Debt Investors",
  "Public Market Investors",
  "Angel Syndicates"
];

export const fundingTypes = [
  "Love Money",
  "Business Angels",
  "Honor Loans",
  "Crowdfunding",
  "Venture Capital",
  "Incubators and Accelerators",
  "Private Equity",
  "Equity Financing",
  "Debt Financing",
  "Mezzanine Financing",
  "Leasing (Credit Lease)",
  "Bond Financing",
  "Strategic Partnerships",
  "Grants and Public Subsidies",
  "Factoring Financing",
  "Sovereign Wealth Funds",
  "Bank Loans"
];

export const PRICING_COST_CONFIG = {
  REACT_SHARE_PROJECT_COST: 100,
  ADD_PROJECT_COST: 2110,
  ACCESS_INVESTORS_LIST_COST: 100,
  CONTACT_INVESTORS_COST: 320,
  ACCEPT_CONTACT_COST: 100,
  PUBLIC_DISPLAY_BY_MONTH_COST: 320,
  NEWSLETTER_VIP_BY_MONTH_COST: 210,
  CLUB_VIP_BY_MONTH_COST: 215
};

export const SUBSCRIPTION_LIMITS = {
  basic: 1,
  standard: 4,
  premium: 10,
};